<template>
    <page>
        <module>
            <view-list ref="view" :work-type="workType" :view-config="saasInfo.viewmanage">
                <template #search>
                    <m-search ref="search" :extend-data="defaultSearchData">
                        <!-- 平台积分账户余额汇总 -->
                        <div class="stats-bar flex">
                            <div class="stats-card card-orange">
                                <div class="stats-info">
                                    <div class="stats-title-row flex-start-center">
                                        <span class="stats-label">保证金余额</span>
                                        <span class="stats-value">{{formatPrice(balance.deposit_balance)}}</span>
                                    </div>
                                </div>
                                <div class="stats-icon">元</div>
                            </div>
                        </div>

                        <m-search-item label="记录单号">
                            <c-input name="record_number"></c-input>
                        </m-search-item>
                        <m-search-item label="创建时间">
                            <c-datetime range name="start_date" end-name="end_date"></c-datetime>
                        </m-search-item>
                    </m-search>
                </template>

                <template #operate>
                    <c-button v-if="auth('b_purchase_supplier_export')"
                              prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出
                    </c-button>
                </template>

                <!--账户类型-->
                <template #account_type="{data}">
                    <c-state tag async dict="ACCOUNT_TYPE" :value="data.account_type"></c-state>
                </template>
                <!--收支类型-->
                <template #income_expenses="{data}">
                    <c-state tag async dict="INCOME_EXPENSES" :value="data.income_expenses"></c-state>
                </template>
                <!--收支状态-->
                <template #trans_state="{data}">
                    <c-state tag async dict="TRANS_STATE" :value="data.trans_state"></c-state>
                </template>
                <!--资金-->
                <template #money="{data}">
                    ￥{{data.money}}
                </template>
                <!--余额-->
                <template #surplus_money="{data}">
                    ￥{{data.surplus_money}}
                </template>
            </view-list>
        </module>
    </page>
</template>

<script>
import {mapState} from 'vuex'
import accountDeduction from "@/pages/finance/saas_account_deduction.vue";

export default {
    name:'p_finance_saas_deposit_record',

    components: {
    },

    data() {
        return {
            workType: 112,
            defaultSearchData: {
                user_type:0,     //默认查询主账号数据
                trans_states:[1,3]  //不展示【2：处理中】的记录
            },
            balance: {
                deposit_balance: 0
            },
            payEnabled:true,
            ids:[],
            withdraw_account_type:0 //账户类型 1=通联账户  2=三方同售账户
        }
    },
    mounted() {
        this.loadBalance();
    },
    computed: {
        // 获取dictName选项数据
        ...mapState(['saasInfo'])
    },

    methods: {
        /**
         * 加载平台积分账户余额汇总（顶部资金汇总卡片）
         */
        loadBalance() {
            this.request({
                url: '/financial/platform/account/balance',
                data: {},
                success: data => {
                    this.balance = {
                        deposit_balance: data && data.deposit_balance ? data.deposit_balance : 0,
                    };
                }
            });
        },

        /**
         *格式化（积分无单位换算，直接展示数值）
         */
        formatPrice(price) {
            if (price === null || price === undefined || price === '') return '-';
            return '¥' + parseFloat(price).toFixed(2);
        },
    }
}
</script>

<style lang="stylus" scoped>
.stats-bar {
    flex-wrap: wrap;
    gap: 10px;
    width: 100%;
    border-top: 1px solid #F5F5F5;
    padding: 8px 12px;

    .stats-card {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex: 1 1 260px;
        max-width: 45%;
        min-height: 56px;
        padding: 8px 16px;
        border-radius: 6px;
        color: #fff;
        box-sizing: border-box;
        overflow: hidden;

        &.card-orange {
            background: linear-gradient(90deg, #f97316, #fb923c);
        }

        &.card-green {
            background: linear-gradient(90deg, #16a34a, #22c55e);
        }

        .stats-info {
            position: relative;
            z-index: 1;

            .stats-title-row {
                display: flex;
                align-items: baseline;
                line-height: 24px;

                .stats-label {
                    font-size: 12px;
                    opacity: 0.95;
                }

                .stats-value {
                    margin-left: 6px;
                    font-size: 18px;
                    font-weight: bold;
                }
            }

            .stats-summary-row {
                gap: .5em;
                margin-top: 2px;
                font-size: 11px;

                label {
                    opacity: 0.9;
                }
            }
        }

        .stats-icon {
            position: absolute;
            right: 14px;
            top: 50%;
            transform: translateY(-50%);
            font-size: 32px;
            line-height: 1;
            opacity: 0.15;
        }
    }
}
</style>